import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ea784c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ChangesHistory" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Инициатор:", -1))
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Время:", -1))
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Действие:", -1))
const _hoisted_8 = {
  key: 0,
  class: "flex"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Старое значение:", -1))
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Новое значение:", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_changes_history_filters = _resolveComponent("changes-history-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.current_item)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large",
          title: "История изменений",
          "confirm-button-text": "Закрыть",
          loading: _ctx.loading,
          onCancel: _ctx.closeModal,
          onConfirm: _ctx.closeModal,
          "without-footer": "",
          scrollable: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_ctx.state.current_item.email), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.state.current_item.createdAt), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_ctx.state.current_item.actionName), 1)
            ]),
            (_ctx.isEditItem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", null, _toDisplayString(_ctx.getDifferences(_ctx.state.current_item, 'old', 'modal')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              (_ctx.isEditItem)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.getDifferences(_ctx.state.current_item, 'new', 'modal')), 1))
                : (_ctx.state.current_item)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNewValueArr(_ctx.state.current_item), (value, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `value-${i}`
                        }, _toDisplayString(value), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "История изменений" }),
    _createVNode(_component_changes_history_filters, {
      class: "mt-6",
      loading: _ctx.data_state.changes_history.is_loading,
      onSubmit: _ctx.onSubmitFilters,
      onReset: _ctx.onResetFilters
    }, null, 8, ["loading", "onSubmit", "onReset"]),
    (_ctx.isSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (
                    _ctx.data_state.changes_history.is_failed &&
                    !_ctx.data_state.changes_history.failure.error_state.is_cancel
                )
            ? (_openBlock(), _createBlock(_component_failed_fetch, {
                key: 0,
                loading: _ctx.data_state.changes_history.is_loading,
                text: "При получении списка историй изменений произошла ошибка",
                "error-message": _ctx.data_state.changes_history.failure.error_state.message,
                "error-url": _ctx.data_state.changes_history.failure.error_state.url,
                "error-status": _ctx.data_state.changes_history.failure.error_state.status,
                onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadChangesHistory(_ctx.data_state.changes_history.pagination.current_page)))
              }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
            : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                key: 1,
                loading: _ctx.data_state.changes_history.is_loading
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_table, {
                    loading: _ctx.data_state.changes_history.is_loading,
                    columns: _ctx.ChangesHistoryColumns,
                    rows: _ctx.data_state.changes_history.list,
                    pagination: "",
                    "pagination-current-page": _ctx.data_state.changes_history.pagination.current_page,
                    "pagination-limit": _ctx.data_state.changes_history.pagination.limit,
                    "pagination-total-items": _ctx.data_state.changes_history.pagination.total_items,
                    "pagination-total-pages": _ctx.data_state.changes_history.pagination.total_pages,
                    onChangePage: _ctx.loadChangesHistory
                  }, {
                    td: _withCtx(({ row, column }) => [
                      (column.key === 'old_value')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getDifferences(row, 'old', 'table')), 1)
                          ], 64))
                        : (column.key === 'new_value')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.getDifferences(row, 'new', 'table')), 1)
                            ], 64))
                          : (
                                column.key === 'a_s' &&
                                row.historyType &&
                                row.historyType.name === 'AdditionalServiceValue'
                            )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(row.new_value ? row.new_value.type_name : '-'), 1)
                              ], 64))
                            : (column.key === 'type' && row.historyType)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createTextVNode(_toDisplayString(row.historyType.description), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                ], 64))
                    ]),
                    actions: _withCtx(({ row }) => [
                      _createVNode(_component_the_button, {
                        hint: "Подробнее",
                        class: "primary extra-small",
                        onClick: ($event: any) => (_ctx.showModal(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
                ]),
                _: 1
              }, 8, ["loading"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}